const applications = [
	{
		name: "apps-applications-list",
		path: "/apps/hr/applications/list",
    component: () => import('@/2-hr/applications/applications-list/ApplicationsList.vue'),
    meta: {authRequired: true, resource: 'hr', action: 'read'},
	},
	{
		name: "apps-applications-view",
		path: "/apps/hr/applications/view/:id",
    component: () => import('@/2-hr/applications/applications-view/ApplicationView.vue'),
    meta: {authRequired: true, resource: 'hr', action: 'read'},
	}
]

const personels = [
	{
		name: "apps-personels-list",
		path: "/apps/hr/personels/list",
    component: () => import('@/2-hr/personels/personel-list/PersonelList.vue'),
    meta: {authRequired: true, resource: 'hr', action: 'read'},
	},
	{
		name: "apps-personels-view",
		path: "/apps/hr/personels/view/:id",
    component: () => import('@/2-hr/personels/personel-view/PersonelView.vue'),
    meta: {authRequired: true, resource: 'hr', action: 'read'},
	},
	{
		name: "apps-personels-edit",
		path: "/apps/hr/personels/edit/:id",
    component: () => import('@/2-hr/personels/personel-edit/PersonelEdit.vue'),
    meta: {authRequired: true, resource: 'hr', action: 'write'},
	}
]

const communications = [
	{
		name: "apps-communications-list",
		path: "/apps/hr/communications/list",
    component: () => import('@/2-hr/communications/communication-list/CommunicationList.vue'),
    meta: {authRequired: true, resource: 'hr', action: 'read', layout: 'vertical'},
	}
  // {
  //  name: "apps-communications-view",
  //	path: "/apps/hr/communications/view",
  //   component: () => import('@/2-hr/communications/communication-view/CommunicationView.vue'),
  // },
  // {
  //  name: "apps-communications-edit",
  //	path: "/apps/hr/communications/edit",
  //   component: () => import('@/2-hr/communications/communication-edit/CommunicationEdit.vue'),
  // },
]

const messages = [
  {
    path: '/apps/hr/messages/edit/:type/:id?', // use when user go to /apps/hr/communications/list and click Edit
    name: 'apps-messages-edit',
    component: () => import('@/2-hr/messages/message-editor.vue'),
    meta: {
      authRequired: true,
      resource: 'hr',
      action: 'edit'
    },
  },
]

const documents = [
	{
		name: "apps-document-requests-list",
		path: "/apps/hr/document-requests/list",
    component: () => import('@/2-hr/document-requests/document-request-list/DocumentRequestList.vue'),
    meta: {authRequired: true, resource: 'hr', action: 'read'},
	},
	{
		name: "apps-document-requests-view",
		path: "/apps/hr/document-requests/view/:id",
    component: () => import('@/2-hr/document-requests/document-request-view/DocumentRequestView.vue'),
    meta: {authRequired: true, resource: 'hr', action: 'read'}
	}
]

const questionnaire = [
	{
		name: "apps-questionnaire-view",
		path: "/apps/hr/questionnaire/view/:id",
    component: () => import('@/2-hr/questionnaire/questionnaire-view/QuestionnaireView.vue'),
    meta: {authRequired: true, resource: 'hr', action: 'read'},
	}
]

export default [
  ...applications,
  ...personels,
  ...communications,
  ...messages,
  ...questionnaire,
  ...documents,
]
